// @flow
import React, { Component } from 'react';
import moment from 'moment';
import { Range } from 'rc-slider';
import { Wrapper, handleStyle, trackStyle, railStyle } from './style';
// rc-slider CSS is embedded in ./style.js to avoid import issues in production

const today = moment().format('YYYY');
const year = parseInt(today, 0) + 2;

type State = {
  firstYear: number,
  lastYear: number,
  isInteracting: boolean
};

type Props = {
  firstYear: number,
  lastYear: number,
  onChange: ({ min: number, max: number }) => void,
  updateInPlace: boolean,
  width?: string
};

class YearSelect extends Component<Props, State> {
  state = {
    firstYear: this.props.firstYear,
    lastYear: this.props.lastYear,
    isInteracting: false
  };

  debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      const later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  debouncedChange = this.debounce(function() {
    this.props.onChange({
      min: this.state.firstYear,
      max: this.state.lastYear
    });
  }, 500);

  componentDidUpdate(prevProps) {
    if (
      !this.state.isInteracting &&
      (prevProps.firstYear !== this.props.firstYear ||
        prevProps.lastYear !== this.props.lastYear)
    ) {
      this.setState({
        firstYear: this.props.firstYear,
        lastYear: this.props.lastYear
      });
    }
  }

  handleBeforeChange = () => {
    this.setState({ isInteracting: true });
  };

  handleChange = value => {
    let firstYear = value[0];
    let lastYear = value[1];

    firstYear = firstYear >= 1900 ? firstYear : 1900;
    lastYear = lastYear <= year ? lastYear : year;

    this.setState({ firstYear, lastYear });
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      const { firstYear, lastYear } = this.state;
      if (firstYear <= lastYear) {
        this.debouncedChange();
      }
    }
  };

  handleMinValue = e => {
    const value = parseInt(e.target.value, 10) || 0;
    this.setState({ firstYear: value }, () => {
      this.debouncedChange();
    });
  };

  handleMaxValue = e => {
    const value = parseInt(e.target.value, 10) || 0;
    this.setState({ lastYear: value }, () => {
      this.debouncedChange();
    });
  };

  handleBlurMin = e => {
    let value = parseInt(e.target.value, 10) || 0;
    const { lastYear } = this.state;

    value = value < 1900 ? 1900 : value > lastYear ? lastYear : value;

    this.setState({ firstYear: value }, () => {
      this.debouncedChange();
    });
  };

  handleBlurMax = e => {
    let value = parseInt(e.target.value, 10) || 0;
    const { firstYear } = this.state;

    value = value > year ? year : value < firstYear ? firstYear : value;

    this.setState({ lastYear: value }, () => {
      this.debouncedChange();
    });
  };

  render() {
    const { firstYear, lastYear } = this.state;
    const { width = '350px' } = this.props;

    return (
      <Wrapper width={width}>
        <div className="row-years">
          <div className="input-zone">
            <input
              type="number"
              value={firstYear || ''}
              onChange={this.handleMinValue}
              onKeyPress={this.handleKeyPress}
              onBlur={this.handleBlurMin}
              maxLength={4}
              min={1900}
              max={year}
            />
            <input
              type="number"
              value={lastYear || ''}
              onChange={this.handleMaxValue}
              onKeyPress={this.handleKeyPress}
              onBlur={this.handleBlurMax}
              maxLength={4}
              min={1900}
              max={year}
            />
          </div>

          <div>
            <br />
            <div className="range-container">
              <Range
                trackStyle={[trackStyle]}
                handleStyle={[handleStyle, handleStyle]}
                railStyle={railStyle}
                onBeforeChange={this.handleBeforeChange}
                onChange={this.handleChange}
                onAfterChange={() => {
                  this.setState({ isInteracting: false }, () => {
                    this.props.onChange({
                      min: this.state.firstYear,
                      max: this.state.lastYear
                    });
                  });
                }}
                value={[firstYear, lastYear]}
                allowCross={false}
                min={1900 - 15}
                max={year + 15}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default YearSelect;



// WEBPACK FOOTER //
// ./src/components/YearSelect/index.js